import db from "@/plugins/dexie";
import apirecebimentoweb from "@/services/api-recebimentoweb";

export default async function $_enviaVisita() {
  if (!navigator.onLine) return;

  try {
    const pendentes = await db.visita
      .filter(v => !v.visidnuvem)
      .toArray();

    if (!pendentes.length) return;

    console.log(`Enviando ${pendentes.length} visitas...`);

    for (const visita of pendentes) {
        try {
            const response = await apirecebimentoweb.post('/visita', visita);
            if (response.data && response.data.id) {
                await db.visita.update(visita.id, { 
                    visidnuvem: response.data.id,
                    visdataalteracao: response.data.visdataalteracao
                });
            }
        } catch (err) {
            console.error(`Erro ao enviar visita do cliente ${visita.idcliente}:`, err);
        }
    }
  } catch (error) {
    console.error("Erro em enviaVisita:", error);
  }
}